import React from 'react';
import PropTypes from 'prop-types';

import Link from '../components/Link';
import Flex from '../components/Flex';
import Spacing from '../components/Spacing';

const defaultProps = {
  onClick: null,
};

const propTypes = {
  onClick: PropTypes.func,
};

const DownloadProgramLink = ({
  onClick,
}) => (
  <Link
    href="https://www.aibes.org/wordpress/wp-content/uploads/2020/07/Programa-OACC.pdf"
    className="py-4 px-6 bg-green-500 font-semibold rounded text-green-50 hover:bg-green-600 focus:bg-green-700 focus:shadow-outline-green"
    target="_blank"
    rel="noopener"
    onClick={onClick}
  >
    <Flex alignItems="center">
      <Spacing right={2} className="hidden lg:block">
        <svg
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-auto fill-current"
        >
          <path
            fillRule="evenodd"
            d="M.5 8a.5.5 0 01.5.5V12a1 1 0 001 1h12a1 1 0 001-1V8.5a.5.5 0 011 0V12a2 2 0 01-2 2H2a2 2 0 01-2-2V8.5A.5.5 0 01.5 8z" clip-rule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M5 7.5a.5.5 0 01.707 0L8 9.793 10.293 7.5a.5.5 0 11.707.707l-2.646 2.647a.5.5 0 01-.708 0L5 8.207A.5.5 0 015 7.5z" clip-rule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M8 1a.5.5 0 01.5.5v8a.5.5 0 01-1 0v-8A.5.5 0 018 1z"
            clipRule="evenodd"
          />
        </svg>
      </Spacing>
      Programa Official Agile Coach
    </Flex>
  </Link>
);

DownloadProgramLink.defaultProps = defaultProps;
DownloadProgramLink.propTypes = propTypes;

export default DownloadProgramLink;
